import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Typography, Tooltip, Grid, Paper, Box, IconButton, Snackbar, MenuItem, Select, FormControl, Tabs, Tab } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import CoreHttpHandler from 'http/services/CoreHttpHandler';
import ButtonOmni from 'allGlobalComponents/ButtonOmni';
import DateRangePickerOmni from 'allGlobalComponents/DateRangePickerOmni';
import ModalOmni from 'allGlobalComponents/ModalOmni';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SyncIcon from '@mui/icons-material/Sync';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import GetAppIcon from '@mui/icons-material/GetApp';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import SendIcon from '@mui/icons-material/Send';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import { Icon } from '@material-ui/core';
import EmailCampaignChart from '../charts/EmailCampaignChart';
import ComposePushEmailModal from '../modals/ComposePushEmailModal';
import ComposeCampaignModal from '../modals/ComposeCampaignModal';
import TableOmniNewAnimated from 'allGlobalComponents/TableOmniNewAnimated';
import DeleteConfirmationDialog from 'allGlobalComponents/DeleteConfirmationDoalog';
import ButtonOmniNew from 'allGlobalComponents/ButtonOmniNew';
import { globalDateFormat } from 'app/constants';

const useStyles = makeStyles(theme => ({
    htmlPreviewContent: {
        color: theme.palette.text.primary,
        fontSize: 14,
        lineHeight: 1.6,
        padding: theme.spacing(1),
        '& img': {
            maxWidth: '100%',
            height: 'auto'
        },
        '& a': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        '& ul': {
            listStyleType: 'disc',
            paddingLeft: 40,
            marginLeft: 0
        },
        '& ol': {
            listStyleType: 'decimal',
            paddingLeft: 40,
            marginLeft: 0
        },
        '& li': {
            display: 'list-item',
            marginBottom: theme.spacing(0.5)
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            color: theme.palette.text.primary,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1)
        },
        '& p': {
            marginBottom: theme.spacing(1)
        }
    },
    noHtmlText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 200,
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
        fontSize: 14
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
        gap: theme.spacing(2)
    },
    leftControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        flexWrap: 'wrap'
    },
    rightControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5)
    },
    datePickerContainer: {
        position: 'relative',
        zIndex: 1000
    },
    chartSection: {
        marginBottom: theme.spacing(3)
    },
    tableSection: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 12,
        overflow: 'hidden'
    },
    statusChip: {
        padding: '4px 12px',
        borderRadius: 16,
        fontSize: 12,
        fontWeight: 500,
        display: 'inline-block',
        textTransform: 'capitalize'
    },
    statusSuccess: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(34, 197, 94, 0.2)' : 'rgba(34, 197, 94, 0.1)',
        color: theme.palette.type === 'dark' ? '#4ADE80' : '#16A34A'
    },
    statusDelivered: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.1)',
        color: theme.palette.type === 'dark' ? '#34D399' : '#059669'
    },
    statusQueue: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(245, 158, 11, 0.2)' : 'rgba(245, 158, 11, 0.1)',
        color: theme.palette.type === 'dark' ? '#FBBF24' : '#D97706'
    },
    statusFailed: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(239, 68, 68, 0.2)' : 'rgba(239, 68, 68, 0.1)',
        color: theme.palette.type === 'dark' ? '#F87171' : '#DC2626'
    },
    statusReceived: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.1)',
        color: theme.palette.type === 'dark' ? '#A78BFA' : '#7C3AED'
    },
    statusInstant: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.1)',
        color: theme.palette.type === 'dark' ? '#60A5FA' : '#2563EB'
    },
    statusSchedule: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(245, 158, 11, 0.2)' : 'rgba(245, 158, 11, 0.1)',
        color: theme.palette.type === 'dark' ? '#FBBF24' : '#D97706'
    },
    statusCompleted: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.1)',
        color: theme.palette.type === 'dark' ? '#34D399' : '#059669'
    },
    buttonIcon: {
        marginRight: theme.spacing(0.5),
        fontSize: 18
    },
    snoCell: {
        fontWeight: 500,
        color: theme.palette.text.secondary
    },
    overviewCard: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
        borderRadius: 16,
        height: '100%',
        boxShadow: theme.palette.type === 'dark'
            ? '0 4px 20px rgba(0, 0, 0, 0.3)'
            : '0 4px 20px rgba(0, 0, 0, 0.08)'
    },
    overviewTitle: {
        fontWeight: 700,
        marginBottom: theme.spacing(3),
        color: theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        fontSize: '1.1rem'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'repeat(2, 1fr)'
        }
    },
    statCard: {
        padding: theme.spacing(2.5),
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        transition: 'all 0.3s ease',
        cursor: 'default',
        border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'}`,
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.palette.type === 'dark'
                ? '0 8px 24px rgba(0,0,0,0.4)'
                : '0 8px 24px rgba(0,0,0,0.12)'
        }
    },
    statIconWrapper: {
        width: 48,
        height: 48,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5)
    },
    statIcon: {
        fontSize: 24
    },
    statValue: {
        fontSize: '2rem',
        fontWeight: 800,
        lineHeight: 1.1,
        marginBottom: theme.spacing(0.5)
    },
    statLabel: {
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.8px',
        opacity: 0.7
    },
    refreshButton: {
        padding: 8,
        color: theme.palette.type === 'dark' ? '#FFFFFF' : '#000000',
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        },
        '& .MuiSvgIcon-root': {
            fontSize: 24,
            fontWeight: 'bold'
        }
    },
    attachmentCountChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        padding: '4px 10px',
        borderRadius: 16,
        fontSize: 12,
        fontWeight: 500,
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.1)',
        color: theme.palette.type === 'dark' ? '#60A5FA' : '#2563EB'
    },
    viewText: {
        color: theme.palette.type === 'dark' ? '#9CA3AF' : '#6B7280',
        fontWeight: 500,
        fontSize: '1.2rem',
        cursor: 'pointer',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        '&:hover': {
            color: theme.palette.type === 'dark' ? '#D1D5DB' : '#374151',
            textDecoration: 'underline'
        }
    },
    attachmentTabsContainer: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(2)
    },
    attachmentTab: {
        minHeight: 48,
        textTransform: 'none',
        fontSize: 13,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        '&.Mui-selected': {
            color: theme.palette.type === 'dark' ? '#FFFFFF' : theme.palette.primary.main
        }
    },
    attachmentPreviewContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        padding: theme.spacing(3),
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.02)',
        borderRadius: 12,
        border: `1px solid ${theme.palette.divider}`
    },
    attachmentImage: {
        maxWidth: '100%',
        maxHeight: 400,
        borderRadius: 8,
        objectFit: 'contain'
    },
    attachmentVideo: {
        maxWidth: '100%',
        maxHeight: 400,
        borderRadius: 8
    },
    attachmentFileInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(4)
    },
    attachmentFileIcon: {
        fontSize: 80,
        color: theme.palette.type === 'dark' ? '#9CA3AF' : '#6B7280'
    },
    attachmentFileName: {
        fontSize: 16,
        fontWeight: 500,
        color: theme.palette.text.primary,
        textAlign: 'center',
        wordBreak: 'break-all'
    },
    attachmentFileType: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    downloadButton: {
        marginTop: theme.spacing(2)
    },
    noAttachmentText: {
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
        fontSize: 14
    },
    typeSelect: {
        minWidth: 150,
        '& .MuiSelect-select': {
            padding: theme.spacing(1, 2),
            backgroundColor: theme.palette.type === 'dark' ? '#374151' : '#FFFFFF',
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 500
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
            borderRadius: 8
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main
        }
    },
    selectContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    viewDialogContent: {
        padding: theme.spacing(2)
    },
    viewSection: {
        marginBottom: theme.spacing(2)
    },
    viewHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(0.5)
    },
    viewLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.type === 'dark' ? '#9CA3AF' : theme.palette.text.secondary,
    },
    viewValue: {
        fontSize: 14,
        color: theme.palette.type === 'dark' ? '#E5E7EB' : theme.palette.text.primary,
        padding: theme.spacing(1.5),
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
        borderRadius: 8,
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap'
    },
    htmlPreview: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.type === 'dark' ? '#111827' : '#FFFFFF',
        borderRadius: 8,
        border: `1px solid ${theme.palette.divider}`,
        maxHeight: 300,
        overflow: 'auto',
        '& img': {
            maxWidth: '100%'
        },
        '& p, & span, & div, & td, & th': {
            color: theme.palette.type === 'dark' ? '#E5E7EB' : 'inherit'
        },
        '& a': {
            color: theme.palette.type === 'dark' ? '#60A5FA' : theme.palette.primary.main,
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            color: theme.palette.type === 'dark' ? '#FFFFFF' : 'inherit'
        },
        '& ul': {
            listStyleType: 'disc',
            paddingLeft: 40,
            marginLeft: 0
        },
        '& ol': {
            listStyleType: 'decimal',
            paddingLeft: 40,
            marginLeft: 0
        },
        '& li': {
            display: 'list-item',
            color: theme.palette.type === 'dark' ? '#E5E7EB' : 'inherit',
            marginBottom: theme.spacing(0.5)
        }
    },
    copyIconButton: {
        padding: 6,
        color: theme.palette.type === 'dark' ? '#9CA3AF' : '#6B7280',
        '&:hover': {
            backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
            color: theme.palette.primary.main
        }
    },
    copyIconButtonSuccess: {
        color: '#22C55E',
        '&:hover': {
            color: '#22C55E'
        }
    },
    percentageChip: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 50,
        padding: '4px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600
    }
}));

// Helper function to get file type from URL or filename
const getFileType = (url, filename) => {
    const name = filename || url || '';
    const extension = name.split('.').pop()?.toLowerCase();

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'];
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'wmv', 'flv'];
    const pdfExtensions = ['pdf'];
    const docExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'];

    if (imageExtensions.includes(extension)) return 'image';
    if (videoExtensions.includes(extension)) return 'video';
    if (pdfExtensions.includes(extension)) return 'pdf';
    if (docExtensions.includes(extension)) return 'document';
    return 'file';
};

// Helper function to get file icon based on type
const getFileIcon = (fileType, classes) => {
    switch (fileType) {
        case 'image':
            return <ImageIcon className={classes.attachmentFileIcon} />;
        case 'video':
            return <VideoLibraryIcon className={classes.attachmentFileIcon} />;
        case 'pdf':
            return <PictureAsPdfIcon className={classes.attachmentFileIcon} />;
        case 'document':
            return <DescriptionIcon className={classes.attachmentFileIcon} />;
        default:
            return <InsertDriveFileIcon className={classes.attachmentFileIcon} />;
    }
};

// Helper function to get filename from attachment
const getAttachmentFilename = (attachment) => {
    if (typeof attachment === 'string') {
        return attachment.split('/').pop() || 'Attachment';
    }
    return attachment.filename || attachment.name || attachment.url?.split('/').pop() || 'Attachment';
};

// Helper function to get attachment URL
const getAttachmentUrl = (attachment) => {
    if (typeof attachment === 'string') {
        return attachment;
    }
    return attachment.url || attachment;
};

function CompletedCampaignTab({ userData = null }) {
    const theme = useTheme();
    const classes = useStyles();
    const csvLink = useRef();

    // Type selection state (push or campaign)
    const [selectedType, setSelectedType] = useState('push');

    const [isLoading, setLoading] = useState(true);
    const [isExporting, setIsExporting] = useState(false);
    const [data, setData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [dataForExport, setDataForExport] = useState([]);
    const [copied, setCopied] = useState(false);
    const [currentParams, setCurrentParams] = useState({ limit: 10, page: 0 });

    // Modal states
    const [pushModalOpen, setPushModalOpen] = useState(false);
    const [campaignModalOpen, setCampaignModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingCampaign, setEditingCampaign] = useState(null);

    // View dialog state (for campaign)
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [viewingCampaign, setViewingCampaign] = useState(null);
    const [htmlCopied, setHtmlCopied] = useState(false);
    const [textCopied, setTextCopied] = useState(false);

    // Delete dialog state (for campaign)
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deletingCampaign, setDeletingCampaign] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    // Attachment Preview Modal State (for push)
    const [attachmentPreviewOpen, setAttachmentPreviewOpen] = useState(false);
    const [selectedAttachments, setSelectedAttachments] = useState([]);
    const [activeAttachmentTab, setActiveAttachmentTab] = useState(0);

    const [htmlPreviewOpen, setHtmlPreviewOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);

    // Helper function to highlight template parameters in HTML
    const highlightTemplateParams = (html) => {
        if (!html) return '';
        // Match {{1}}, {{2}}, etc. and wrap them in a styled span with lime green background
        return html.replace(/\{\{(\d+)\}\}/g, (match) => {
            return `<span style="background-color: #a3e635; color: #1a1a1a; padding: 2px 6px; border-radius: 4px; font-weight: 600; font-family: monospace;">${match}</span>`;
        });
    };
    // Download columns configuration for Push Emails
    const pushDownloadColumns = {
        'id': 'ID',
        'sender_email': 'Sender Email',
        'receiver_email': 'Receiver Email',
        'subject': 'Subject',
        'status': 'Status',
        'text': 'Email Text',
        'html': 'Email HTML',
        'total_count': 'Total',
        'success_count': 'Success',
        'delivered_count': 'Delivered',
        'received_count': 'Received',
        'queue_count': 'Queue',
        'failed_count': 'Failed',
        'compliant_count': 'Compliant',
        'delivery_percentage': 'Delivery %',
        'attachments': 'Attachments',
        'dt': 'Date',
        'error_message': 'Response Message'
    };

    // Download columns configuration for Campaigns
    const campaignDownloadColumns = {
        'id': 'ID',
        'recipient_id': 'Recipient Id',
        'sender_email': 'Sender Email',
        'email_subject': 'Subject',
        'campaign_type': 'Type',
        'email_template_name': 'Email Template Name',
        'email_template_body': 'Email Template Body',
        'email_template_html': 'Email Template HTML',
        'total_count': 'Total',
        'success_count': 'Success',
        'delivered_count': 'Delivered',
        'received_count': 'Received',
        'queue_count': 'Queue',
        'failed_count': 'Failed',
        'compliant_count': 'Compliant',
        'delivery_percentage': 'Delivery %',
        'attachments': 'Attachments',
        'time': 'Scheduled Time',
        'dt': 'Date'
    };

    // Handle HTML preview
    const handleViewHtml = (row) => {
        setSelectedEmail(row);
        setHtmlPreviewOpen(true);
    };

    const handleCloseHtmlPreview = () => {
        setHtmlPreviewOpen(false);
        setSelectedEmail(null);
    };

    // Extract body content from HTML
    const extractBodyContent = (html) => {
        if (!html) return '';
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) return bodyMatch[1];
        return html;
    };

    // Snackbar state
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const [dateRange, setDateRange] = useState({
        startDate: moment.utc().startOf('day'),
        endDate: moment.utc().endOf('day')
    });

    // Show snackbar helper
    const showSnackbar = (message, severity = 'success') => {
        setSnackbar({ open: true, message, severity });
    };

    // Handle snackbar close
    const handleSnackbarClose = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    // Get attachment count
    const getAttachmentCount = (attachments) => {
        if (!attachments) return 0;
        if (Array.isArray(attachments)) return attachments.length;
        return 0;
    };

    // Handle Attachment preview
    const handleViewAttachments = (row) => {
        const attachments = row.attachments || [];
        setSelectedAttachments(attachments);
        setActiveAttachmentTab(0);
        setAttachmentPreviewOpen(true);
    };

    const handleCloseAttachmentPreview = () => {
        setAttachmentPreviewOpen(false);
        setSelectedAttachments([]);
        setActiveAttachmentTab(0);
    };

    const handleAttachmentTabChange = (event, newValue) => {
        setActiveAttachmentTab(newValue);
    };

    const handleDownloadAttachment = (attachment) => {
        const url = getAttachmentUrl(attachment);
        const filename = getAttachmentFilename(attachment);

        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(error => {
                console.error('Download failed:', error);
                window.open(url, '_blank');
            });
    };

    // Render attachment preview content
    const renderAttachmentPreview = () => {
        if (selectedAttachments.length === 0) {
            return (
                <div className={classes.attachmentPreviewContainer}>
                    <Typography className={classes.noAttachmentText}>No attachments available</Typography>
                </div>
            );
        }

        const currentAttachment = selectedAttachments[activeAttachmentTab];
        const url = getAttachmentUrl(currentAttachment);
        const filename = getAttachmentFilename(currentAttachment);
        const fileType = getFileType(url, filename);

        return (
            <div className={classes.attachmentPreviewContainer}>
                {fileType === 'image' ? (
                    <>
                        <img
                            src={url}
                            alt={filename}
                            className={classes.attachmentImage}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                        />
                        <div className={classes.attachmentFileInfo} style={{ display: 'none' }}>
                            {getFileIcon(fileType, classes)}
                            <Typography className={classes.attachmentFileName}>{filename}</Typography>
                            <ButtonOmni
                                onClick={() => handleDownloadAttachment(currentAttachment)}
                                label="Download"
                                size="small"
                                startIcon={<GetAppIcon />}
                                className={classes.downloadButton}
                            />
                        </div>
                    </>
                ) : fileType === 'video' ? (
                    <video
                        src={url}
                        controls
                        className={classes.attachmentVideo}
                    >
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <div className={classes.attachmentFileInfo}>
                        {getFileIcon(fileType, classes)}
                        <Typography className={classes.attachmentFileName}>{filename}</Typography>
                        <Typography className={classes.attachmentFileType}>
                            {filename.split('.').pop()?.toUpperCase() || 'FILE'}
                        </Typography>
                        <ButtonOmni
                            onClick={() => handleDownloadAttachment(currentAttachment)}
                            label="Download"
                            size="small"
                            startIcon={<GetAppIcon />}
                            className={classes.downloadButton}
                        />
                    </div>
                )}
            </div>
        );
    };

    // Fetch data based on selected type
    const fetchData = () => {
        setLoading(true);

        if (selectedType === 'push') {
            const apiPayload = {
                startDate: dateRange.startDate,
                endDate: dateRange.endDate,
                limit: currentParams.limit,
                page: currentParams.page,
                campaign_id: 0,
                status: ["delivered", "success", "received"]
            };

            if (userData?.id) {
                apiPayload.clientId = userData?.id;
            }

            CoreHttpHandler.request(
                'emailCampaign',
                'OutboundEmailsList',
                apiPayload,
                response => {
                    const res = response.data.data.data.emailsList || [];
                    const totalCount = response.data.data.data.totalItems || 0;
                    setData(res);
                    setTotalItems(totalCount);
                    setLoading(false);
                },
                error => {
                    console.error('Error fetching emails:', error);
                    setData([]);
                    setTotalItems(0);
                    setLoading(false);
                    showSnackbar('Failed to fetch emails', 'error');
                }
            );
        } else {
            const apiPayload = {
                startDate: dateRange.startDate,
                endDate: dateRange.endDate,
                limit: currentParams.limit,
                page: currentParams.page,
                campaign_type: ["completed"]

            };
            if (userData?.id) {
                apiPayload.clientId = userData?.id;
            }
            CoreHttpHandler.request(
                'emailCampaign',
                'emailsCampaignFetch',
                apiPayload,
                response => {
                    const res = response.data.data.data.emailCampaigns || [];
                    const totalCount = response.data.data.data.totalItems || res.length || 0;
                    setData(Array.isArray(res) ? res : [res]);
                    setTotalItems(totalCount);
                    setLoading(false);
                },
                error => {
                    console.error('Error fetching campaigns:', error);
                    setData([]);
                    setTotalItems(0);
                    setLoading(false);
                    showSnackbar('Failed to fetch campaigns', 'error');
                }
            );
        }
    };

    const fetchAllDataForExport = () => {
        return new Promise((resolve, reject) => {
            if (selectedType === 'push') {
                const apiPayload = {
                    startDate: dateRange.startDate,
                    endDate: dateRange.endDate,
                    limit: totalItems || 10000,
                    page: 0,
                    status: ["delivered", "success", "received"]
                };

                if (userData?.id) {
                    apiPayload.clientId = userData?.id;
                }

                CoreHttpHandler.request(
                    'emailCampaign',
                    'OutboundEmailsList',
                    apiPayload,
                    response => {
                        const res = response.data.data.data.emailsList || [];
                        resolve(res);
                    },
                    error => {
                        reject(error);
                    }
                );
            } else {
                const apiPayload = {
                    startDate: dateRange.startDate,
                    endDate: dateRange.endDate,
                    limit: totalItems || 10000,
                    page: 0,
                    campaign_type: ["completed"]
                };
                if (userData?.id) {
                    apiPayload.clientId = userData?.id;
                }
                CoreHttpHandler.request(
                    'emailCampaign',
                    'emailsCampaignFetch',
                    apiPayload,
                    response => {
                        const res = response.data.data.data.emailCampaigns || [];
                        resolve(Array.isArray(res) ? res : [res]);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        });
    };

    const generateFileName = () => {
        const today = moment().format('YYYY-MM-DD');
        const typeLabel = selectedType === 'push' ? 'push_emails' : 'campaigns';
        return `${typeLabel}_${dateRange.startDate.format('YYYY-MM-DD')}_to_${dateRange.endDate.format('YYYY-MM-DD')}_${today}.csv`;
    };

    // Helper for CSVLink export (react-csv handles quote escaping automatically)
    const sanitizeForBulkExport = (value) => {
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value !== 'string') return String(value);

        // Remove newlines completely for bulk export to prevent row breaking
        // react-csv will handle quote escaping
        return value
            .replace(/\r\n/g, ' ')
            .replace(/\r/g, ' ')
            .replace(/\n/g, ' ')
            .replace(/\s+/g, ' ')
            .trim() || '-';
    };

    // Helper for single row export (we handle escaping manually)
    const sanitizeForSingleExport = (value) => {
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value !== 'string') return String(value);

        // Keep newlines for Excel multi-line cells
        return value
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n') || '-';
    };

    // Handle single row download
    const handleDownloadSingleRow = (row) => {
        const filename = `${selectedType === 'push' ? 'push_email' : 'campaign'}_${row.id || 'export'}_${moment().format('YYYY-MM-DD')}.csv`;

        // Escape value for CSV - handle quotes and preserve newlines
        const escapeCSV = (value) => {
            if (value === null || value === undefined) return '"-"';
            const str = String(value);
            // Escape quotes by doubling them, then wrap in quotes
            const escaped = str.replace(/"/g, '""');
            return `"${escaped}"`;
        };

        let formattedRow;

        if (selectedType === 'push') {
            formattedRow = {
                'ID': row.id || '-',
                'Sender Email': row.sender_email || '-',
                'Receiver Email': row.receiver_email || '-',
                'Subject': row.subject || '-',
                'Status': capitalizeWords(row.status),
                'Email Text': sanitizeForSingleExport(row.text),
                'Email HTML': sanitizeForSingleExport(row.html),
                'Total': row.total_count ?? 0,
                'Success': row.success_count ?? 0,
                'Delivered': row.delivered_count ?? 0,
                'Received': row.received_count ?? 0,
                'Queue': row.queue_count ?? 0,
                'Failed': row.failed_count ?? 0,
                'Compliant': row.compliant_count ?? 0,
                'Delivery %': calculateDeliveryPercentage(row),
                'Attachments': row.attachments ? (Array.isArray(row.attachments) ? row.attachments.length : 0) : 0,
                'Date': row.dt ? moment(row.dt).format(globalDateFormat) : '-',
                'Response Message': sanitizeForSingleExport(row.error_message)
            };
        } else {
            formattedRow = {
                'ID': row.id || '-',
                'Recipient Id': row.recipient_id || '-',
                'Sender Email': row.sender_email || '-',
                'Subject': row.email_subject || '-',
                'Type': capitalizeWords(row.campaign_type),
                'Email Template Name': row.email_template_name || '-',
                'Email Template Body': sanitizeForSingleExport(row.email_template_body),
                'Email Template HTML': sanitizeForSingleExport(row.email_template_html),
                'Total': row.total_count ?? 0,
                'Success': row.success_count ?? 0,
                'Delivered': row.delivered_count ?? 0,
                'Received': row.received_count ?? 0,
                'Queue': row.queue_count ?? 0,
                'Failed': row.failed_count ?? 0,
                'Compliant': row.compliant_count ?? 0,
                'Delivery %': calculateDeliveryPercentage(row),
                'Attachments': row.attachments ? (Array.isArray(row.attachments) ? row.attachments.length : 0) : 0,
                'Scheduled Time': row.time ? moment(row.time).format(globalDateFormat) : '-',
                'Date': row.dt ? moment(row.dt).format(globalDateFormat) : '-'
            };
        }

        const headers = Object.keys(formattedRow);
        const values = Object.values(formattedRow);

        const headerLine = headers.map(h => escapeCSV(h)).join(',');
        const valueLine = values.map(v => escapeCSV(v)).join(',');

        const csvContent = headerLine + '\r\n' + valueLine;

        // BOM for Excel UTF-8 support
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const formatDataForExport = (rawData) => {
        if (!rawData || rawData.length === 0) return [];

        if (selectedType === 'push') {
            return rawData.map((item) => ({
                'ID': item.id || '-',
                'Sender Email': item.sender_email || '-',
                'Receiver Email': item.receiver_email || '-',
                'Subject': sanitizeForBulkExport(item.subject),
                'Status': capitalizeWords(item.status),
                'Email Text': sanitizeForBulkExport(item.text),
                'Email HTML': sanitizeForBulkExport(item.html),
                'Total': item.total_count ?? 0,
                'Success': item.success_count ?? 0,
                'Delivered': item.delivered_count ?? 0,
                'Received': item.received_count ?? 0,
                'Queue': item.queue_count ?? 0,
                'Failed': item.failed_count ?? 0,
                'Compliant': item.compliant_count ?? 0,
                'Delivery %': calculateDeliveryPercentage(item),
                'Attachments': item.attachments ? (Array.isArray(item.attachments) ? item.attachments.length : 0) : 0,
                'Date': item.dt ? moment(item.dt).format(globalDateFormat) : '-',
                'Response Message': sanitizeForBulkExport(item.error_message)
            }));
        } else {
            return rawData.map((item) => ({
                'ID': item.id || '-',
                'Recipient Id': item.recipient_id || '-',
                'Sender Email': item.sender_email || '-',
                'Subject': sanitizeForBulkExport(item.email_subject),
                'Type': capitalizeWords(item.campaign_type),
                'Email Template Name': sanitizeForBulkExport(item.email_template_name),
                'Email Template Body': sanitizeForBulkExport(item.email_template_body),
                'Email Template HTML': sanitizeForBulkExport(item.email_template_html),
                'Total': item.total_count ?? 0,
                'Success': item.success_count ?? 0,
                'Delivered': item.delivered_count ?? 0,
                'Received': item.received_count ?? 0,
                'Queue': item.queue_count ?? 0,
                'Failed': item.failed_count ?? 0,
                'Compliant': item.compliant_count ?? 0,
                'Delivery %': calculateDeliveryPercentage(item),
                'Attachments': item.attachments ? (Array.isArray(item.attachments) ? item.attachments.length : 0) : 0,
                'Scheduled Time': item.time ? moment(item.time).format(globalDateFormat) : '-',
                'Date': item.dt ? moment(item.dt).format(globalDateFormat) : '-'
            }));
        }
    };
    const handleExport = async () => {
        try {
            setIsExporting(true);
            const exportData = await fetchAllDataForExport();
            if (exportData.length === 0) {
                showSnackbar('No data available for export', 'warning');
                setIsExporting(false);
                return;
            }

            // Escape value for CSV
            const escapeCSV = (value) => {
                if (value === null || value === undefined) return '"-"';
                let str = String(value);
                // Remove all newlines and carriage returns
                str = str.replace(/\r\n/g, ' ').replace(/\r/g, ' ').replace(/\n/g, ' ');
                // Replace multiple spaces with single space
                str = str.replace(/\s+/g, ' ').trim();
                // Escape quotes by doubling them
                str = str.replace(/"/g, '""');
                return `"${str}"`;
            };

            let headers = [];
            let rows = [];

            if (selectedType === 'push') {
                headers = [
                    'ID', 'Sender Email', 'Receiver Email', 'Subject', 'Status',
                    'Email Text', 'Email HTML', 'Total', 'Success', 'Delivered',
                    'Received', 'Queue', 'Failed', 'Compliant', 'Delivery %',
                    'Attachments', 'Date', 'Response Message'
                ];

                rows = exportData.map(item => [
                    item.id || '-',
                    item.sender_email || '-',
                    item.receiver_email || '-',
                    item.subject || '-',
                    capitalizeWords(item.status),
                    item.text || '-',
                    item.html || '-',
                    item.total_count ?? 0,
                    item.success_count ?? 0,
                    item.delivered_count ?? 0,
                    item.received_count ?? 0,
                    item.queue_count ?? 0,
                    item.failed_count ?? 0,
                    item.compliant_count ?? 0,
                    calculateDeliveryPercentage(item),
                    item.attachments ? (Array.isArray(item.attachments) ? item.attachments.length : 0) : 0,
                    item.dt ? moment(item.dt).format(globalDateFormat) : '-',
                    item.error_message || '-'
                ]);
            } else {
                headers = [
                    'ID', 'Recipient Id', 'Sender Email', 'Subject', 'Type',
                    'Email Template Name', 'Email Template Body', 'Email Template HTML',
                    'Total', 'Success', 'Delivered', 'Received', 'Queue', 'Failed',
                    'Compliant', 'Delivery %', 'Attachments', 'Scheduled Time', 'Date'
                ];

                rows = exportData.map(item => [
                    item.id || '-',
                    item.recipient_id || '-',
                    item.sender_email || '-',
                    item.email_subject || '-',
                    capitalizeWords(item.campaign_type),
                    item.email_template_name || '-',
                    item.email_template_body || '-',
                    item.email_template_html || '-',
                    item.total_count ?? 0,
                    item.success_count ?? 0,
                    item.delivered_count ?? 0,
                    item.received_count ?? 0,
                    item.queue_count ?? 0,
                    item.failed_count ?? 0,
                    item.compliant_count ?? 0,
                    calculateDeliveryPercentage(item),
                    item.attachments ? (Array.isArray(item.attachments) ? item.attachments.length : 0) : 0,
                    item.time ? moment(item.time).format(globalDateFormat) : '-',
                    item.dt ? moment(item.dt).format(globalDateFormat) : '-'
                ]);
            }

            // Build CSV content
            const headerLine = headers.map(h => escapeCSV(h)).join(',');
            const dataLines = rows.map(row => row.map(cell => escapeCSV(cell)).join(',')).join('\r\n');
            const csvContent = headerLine + '\r\n' + dataLines;

            // BOM for Excel UTF-8 support
            const BOM = '\uFEFF';
            const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', generateFileName());
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            setIsExporting(false);
        } catch (error) {
            console.error('Export failed:', error);
            showSnackbar('Export failed. Please try again.', 'error');
            setIsExporting(false);
        }
    };

    const handleDateChange = ({ startDate, endDate }) => {
        if (startDate && endDate) {
            setDateRange({ startDate, endDate });
            setCurrentParams({ ...currentParams, page: 0 });
        }
    };

    const handleTypeChange = (event) => {
        const value = event.target.value;
        setSelectedType(value);
        setCurrentParams({ limit: 10, page: 0 });
        setData([]);
        setTotalItems(0);
    };

    const copyContent = (content) => {
        copy(content);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const capitalizeWords = (str) => {
        if (!str || typeof str !== 'string') return '-';
        return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    };

    const getStatusClass = (status) => {
        const statusLower = (status || '').toLowerCase();
        switch (statusLower) {
            case 'success': return classes.statusSuccess;
            case 'delivered': return classes.statusDelivered;
            case 'queue': return classes.statusQueue;
            case 'failed': return classes.statusFailed;
            case 'received': return classes.statusReceived;
            default: return '';
        }
    };

    const getCampaignTypeClass = (type) => {
        const typeLower = (type || '').toLowerCase();
        switch (typeLower) {
            case 'instant': return classes.statusInstant;
            case 'schedule': return classes.statusSchedule;
            case 'completed': return classes.statusCompleted;
            default: return '';
        }
    };

    // Calculate delivery percentage
    const calculateDeliveryPercentage = (row) => {
        const total = parseInt(row.total_count) || 0;
        const delivered = parseInt(row.delivered_count) || 0;
        const success = parseInt(row.success_count) || 0;
        if (total === 0) return '0%';
        return (((delivered + success) / total) * 100).toFixed(1) + '%';
    };

    // Get percentage color class
    const getPercentageColor = (percentage) => {
        const value = parseFloat(percentage);
        if (value >= 80) return { backgroundColor: 'rgba(34, 197, 94, 0.15)', color: '#16A34A' };
        if (value >= 50) return { backgroundColor: 'rgba(245, 158, 11, 0.15)', color: '#D97706' };
        return { backgroundColor: 'rgba(239, 68, 68, 0.15)', color: '#DC2626' };
    };

    // Get status counts for push emails
    const getPushStatusCounts = () => ({
        success: data.filter(e => e.status?.toLowerCase() === 'success').length,
        delivered: data.filter(e => e.status?.toLowerCase() === 'delivered').length,
        queue: data.filter(e => e.status?.toLowerCase() === 'queue').length,
        failed: data.filter(e => e.status?.toLowerCase() === 'failed').length,
        received: data.filter(e => e.status?.toLowerCase() === 'received').length
    });

    // Get stats for campaigns
    const getCampaignStats = () => ({
        total: totalItems,
        instant: data.filter(e => e.campaign_type?.toLowerCase() === 'instant').length,
        scheduled: data.filter(e => e.campaign_type?.toLowerCase() === 'schedule').length,
        completed: data.filter(e => e.campaign_type?.toLowerCase() === 'completed').length
    });

    const pushStatusCounts = getPushStatusCounts();
    const campaignStats = getCampaignStats();

    // Handle push email send
    const handleSendPushEmail = (emailData, successMessage) => {
        if (successMessage) {
            showSnackbar(successMessage, 'success');
        }
        fetchData();
    };

    // Handle campaign send/update
    const handleSendCampaign = (campaignData, successMessage) => {
        if (successMessage) {
            showSnackbar(successMessage, 'success');
        }
        setIsEditMode(false);
        setEditingCampaign(null);
        fetchData();
    };

    const handleCloseCampaignModal = () => {
        setCampaignModalOpen(false);
        setIsEditMode(false);
        setEditingCampaign(null);
    };

    const handleRefresh = () => {
        fetchData();
    };

    // Campaign specific functions
    const isCampaignEditable = (campaign) => {
        if (!campaign) return false;
        const campaignType = (campaign.campaign_type || '').toLowerCase();
        if (campaignType === 'completed') {
            return false;
        }
        if (campaign.time && moment(campaign.time).isBefore(moment())) {
            return false;
        }
        return true;
    };

    const replaceParamsInHtml = (html, emailParams) => {
        if (!html || !emailParams?.parameters) return html || '';
        let result = html;
        emailParams.parameters.forEach((param, index) => {
            const placeholder = `{{${index + 1}}}`;
            const regex = new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g');
            result = result.replace(regex, param.value || placeholder);
        });
        return result;
    };

    const getHtmlPreview = (campaign) => {
        const htmlContent = campaign?.email_template_html || campaign?.email_html;
        if (!htmlContent) return '';
        let html = htmlContent;
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) {
            html = bodyMatch[1];
        }
        // Highlight template parameters instead of replacing them
        return highlightTemplateParams(html);
    };

    const handleDeleteClick = (campaign) => {
        setDeletingCampaign(campaign);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (!deletingCampaign) return;
        setIsDeleting(true);
        const apiPayload = { id: deletingCampaign.id.toString() }
        if (userData?.id) {
            apiPayload.clientId = userData?.id;
        }
        CoreHttpHandler.request(
            'emailCampaign',
            'emailsCampaignDelete',
            apiPayload,
            response => {
                setIsDeleting(false);
                setDeleteDialogOpen(false);
                setDeletingCampaign(null);
                showSnackbar('Campaign deleted successfully', 'success');
                fetchData();
            },
            error => {
                console.error('Error deleting campaign:', error);
                setIsDeleting(false);
                showSnackbar('Failed to delete campaign. Please try again.', 'error');
            }
        );
    };

    const handleEditClick = (campaign) => {
        if (!isCampaignEditable(campaign)) {
            return;
        }
        setEditingCampaign(campaign);
        setIsEditMode(true);
        setCampaignModalOpen(true);
    };

    const handleViewClick = (campaign) => {
        setViewingCampaign(campaign);
        setViewDialogOpen(true);
    };

    const handleCloseViewDialog = () => {
        setViewDialogOpen(false);
        setViewingCampaign(null);
        setHtmlCopied(false);
        setTextCopied(false);
    };

    const copyHtml = () => {
        const htmlContent = viewingCampaign?.email_template_html || viewingCampaign?.email_html;
        if (htmlContent) {
            const htmlWithParams = replaceParamsInHtml(htmlContent, viewingCampaign.email_params);
            navigator.clipboard.writeText(htmlWithParams).then(() => {
                setHtmlCopied(true);
                setTimeout(() => setHtmlCopied(false), 2000);
            }).catch(err => {
                console.error('Failed to copy HTML:', err);
                showSnackbar('Failed to copy HTML', 'error');
            });
        }
    };

    // Push email table head cells
    const pushHeadCells = [
        { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
        {
            id: 'sender_email',
            numeric: false,
            disablePadding: false,
            label: 'Sender Email',
            email: true
        },
        {
            id: 'receiver_email',
            numeric: false,
            disablePadding: false,
            label: 'Receiver Email',
            email: true
        },
        {
            id: 'subject',
            numeric: false,
            disablePadding: false,
            label: 'Subject',
            msg: true,
            truncateLength: 30
        },
        {
            id: 'status',
            numeric: false,
            disablePadding: false,
            label: 'Status',
            customRow: row => (
                <span className={`${classes.statusChip} ${getStatusClass(row.status)}`}>
                    {capitalizeWords(row.status) || '-'}
                </span>
            )
        },
        {
            id: 'text',
            numeric: false,
            disablePadding: false,
            label: 'Email Text',
            msg: true,
            truncateLength: 30
        },
        {
            id: 'html',
            numeric: false,
            disablePadding: false,
            label: 'Email HTML',
            customRow: row => (
                row.html ? (
                    <span
                        className={classes.viewText}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleViewHtml(row);
                        }}
                    >
                        VIEW
                    </span>
                ) : (
                    <span style={{ color: theme.palette.text.secondary, fontSize: 13 }}>-</span>
                )
            )
        },
        {
            id: 'total_count',
            numeric: false,
            disablePadding: false,
            label: 'Total',
            customRow: row => row.total_count ?? 0
        },
        {
            id: 'success_count',
            numeric: false,
            disablePadding: false,
            label: 'Success',
            customRow: row => row.success_count ?? 0
        },
        {
            id: 'delivered_count',
            numeric: false,
            disablePadding: false,
            label: 'Delivered',
            customRow: row => row.delivered_count ?? 0
        },
        {
            id: 'received_count',
            numeric: false,
            disablePadding: false,
            label: 'Received',
            customRow: row => row.received_count ?? 0
        },
        {
            id: 'queue_count',
            numeric: false,
            disablePadding: false,
            label: 'Queue',
            customRow: row => row.queue_count ?? 0
        },
        {
            id: 'failed_count',
            numeric: false,
            disablePadding: false,
            label: 'Failed',
            customRow: row => row.failed_count ?? 0
        },
        {
            id: 'compliant_count',
            numeric: false,
            disablePadding: false,
            label: 'Compliant',
            customRow: row => row.compliant_count ?? 0
        },
        {
            id: 'delivery_percentage',
            numeric: false,
            disablePadding: false,
            label: 'Delivery %',
            customRow: row => {
                const percentage = calculateDeliveryPercentage(row);
                const colorStyle = getPercentageColor(percentage);
                return (
                    <span className={classes.percentageChip} style={colorStyle}>
                        {percentage}
                    </span>
                );
            }
        },
        {
            id: 'attachments',
            numeric: false,
            disablePadding: false,
            label: 'Attachments',
            customRow: row => {
                const count = getAttachmentCount(row.attachments);
                return (
                    <span className={classes.attachmentCountChip}>
                        <AttachFileIcon style={{ fontSize: 14 }} />
                        {count}
                    </span>
                );
            }
        },
        {
            id: 'view_attachments',
            numeric: false,
            disablePadding: false,
            label: 'View Attachments',
            customRow: row => {
                const count = getAttachmentCount(row.attachments);
                return count > 0 ? (
                    <span
                        className={classes.viewText}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleViewAttachments(row);
                        }}
                    >
                        VIEW
                    </span>
                ) : (
                    <span style={{ color: theme.palette.text.secondary, fontSize: 13 }}>-</span>
                );
            }
        },

        {
            id: 'dt',
            numeric: false,
            disablePadding: false,
            label: 'Date',
            dt: true
        },
        {
            id: 'error_message',
            numeric: false,
            disablePadding: false,
            label: 'Response Message',
            msg: true,
            truncateLength: 30
        },
        { id: 'download', numeric: false, disablePadding: false, label: 'Download' }
    ];

    // Campaign table head cells 
    const campaignHeadCells = [
        { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
        { id: 'recipient_id', numeric: false, disablePadding: false, label: 'Recipient Id' },
        {
            id: 'sender_email',
            numeric: false,
            disablePadding: false,
            label: 'Sender Email',
            email: true,
        },
        {
            id: 'email_subject',
            numeric: false,
            disablePadding: false,
            label: 'Subject',
            msg: true,
            truncateLength: 30
        },
        {
            id: 'campaign_type',
            numeric: false,
            disablePadding: false,
            label: 'Type',
            customRow: row => (
                <span className={`${classes.statusChip} ${getCampaignTypeClass(row.campaign_type)}`}>
                    {capitalizeWords(row.campaign_type) || '-'}
                </span>
            )
        },
        {
            id: 'view',
            numeric: false,
            disablePadding: false,
            label: 'View Campaign Details',
        },
        {
            id: 'total_count',
            numeric: false,
            disablePadding: false,
            label: 'Total',
            customRow: row => row.total_count ?? 0
        },
        {
            id: 'success_count',
            numeric: false,
            disablePadding: false,
            label: 'Success',
            customRow: row => row.success_count ?? 0
        },
        {
            id: 'delivered_count',
            numeric: false,
            disablePadding: false,
            label: 'Delivered',
            customRow: row => row.delivered_count ?? 0
        },
        {
            id: 'received_count',
            numeric: false,
            disablePadding: false,
            label: 'Received',
            customRow: row => row.received_count ?? 0
        },
        {
            id: 'queue_count',
            numeric: false,
            disablePadding: false,
            label: 'Queue',
            customRow: row => row.queue_count ?? 0
        },
        {
            id: 'failed_count',
            numeric: false,
            disablePadding: false,
            label: 'Failed',
            customRow: row => row.failed_count ?? 0
        },
        {
            id: 'compliant_count',
            numeric: false,
            disablePadding: false,
            label: 'Compliant',
            customRow: row => row.compliant_count ?? 0
        },
        {
            id: 'delivery_percentage',
            numeric: false,
            disablePadding: false,
            label: 'Delivery %',
            customRow: row => {
                const percentage = calculateDeliveryPercentage(row);
                const colorStyle = getPercentageColor(percentage);
                return (
                    <span className={classes.percentageChip} style={colorStyle}>
                        {percentage}
                    </span>
                );
            }
        },
        {
            id: 'attachments',
            numeric: false,
            disablePadding: false,
            label: 'Attachments',
            customRow: row => {
                const count = getAttachmentCount(row.attachments);
                return (
                    <span className={classes.attachmentCountChip}>
                        <AttachFileIcon style={{ fontSize: 14 }} />
                        {count}
                    </span>
                );
            }
        },
        {
            id: 'view_attachments',
            numeric: false,
            disablePadding: false,
            label: 'View Attachments',
            customRow: row => {
                const count = getAttachmentCount(row.attachments);
                return count > 0 ? (
                    <span
                        className={classes.viewText}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleViewAttachments(row);
                        }}
                    >
                        VIEW
                    </span>
                ) : (
                    <span style={{ color: theme.palette.text.secondary, fontSize: 13 }}>-</span>
                );
            }
        },
        {
            id: 'time',
            numeric: false,
            disablePadding: false,
            label: 'Scheduled Time',
            dt: true
        },
        {
            id: 'dt',
            numeric: false,
            disablePadding: false,
            label: 'Date',
            dt: true
        },
        {
            id: 'view',
            numeric: false,
            disablePadding: false,
            label: 'View',
        },
        {
            id: 'edit',
            numeric: false,
            disablePadding: false,
            label: 'Edit',
            customRow: row => {
                const isEditable = isCampaignEditable(row);
                return (
                    <Tooltip
                        title={isEditable ? 'Edit' : 'Campaign completed - cannot edit'}
                        arrow
                    >
                        <span>
                            <EditIcon
                                style={{
                                    cursor: isEditable ? 'pointer' : 'not-allowed',
                                    color: isEditable ? 'inherit' : theme.palette.action.disabled
                                }}
                                fontSize="medium"
                                onClick={() => isEditable && handleEditClick(row)}
                            />
                        </span>
                    </Tooltip>
                );
            }
        },
        {
            id: 'delete',
            numeric: false,
            disablePadding: false,
            label: 'Delete',
        },
        { id: 'download', numeric: false, disablePadding: false, label: 'Download' }
    ];

    useEffect(() => {
        fetchData();
    }, [currentParams, dateRange, selectedType]);

    // Stats config for push
    const pushStatsConfig = [
        {
            label: 'Total Emails',
            value: totalItems,
            color: theme.palette.type === 'dark' ? '#E5E7EB' : '#374151',
            bgColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
            iconBg: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
            icon: <EmailIcon className={classes.statIcon} />
        },
        {
            label: 'Queue',
            value: pushStatusCounts.queue,
            color: '#F59E0B',
            bgColor: theme.palette.type === 'dark' ? 'rgba(245, 158, 11, 0.15)' : 'rgba(245, 158, 11, 0.08)',
            iconBg: 'rgba(245, 158, 11, 0.2)',
            icon: <HourglassEmptyIcon className={classes.statIcon} />
        },
        {
            label: 'Delivered',
            value: pushStatusCounts.delivered,
            color: '#10B981',
            bgColor: theme.palette.type === 'dark' ? 'rgba(16, 185, 129, 0.15)' : 'rgba(16, 185, 129, 0.08)',
            iconBg: 'rgba(16, 185, 129, 0.2)',
            icon: <MarkEmailReadIcon className={classes.statIcon} />
        },
        {
            label: 'Received',
            value: pushStatusCounts.received,
            color: '#8B5CF6',
            bgColor: theme.palette.type === 'dark' ? 'rgba(139, 92, 246, 0.15)' : 'rgba(139, 92, 246, 0.08)',
            iconBg: 'rgba(139, 92, 246, 0.2)',
            icon: <CallReceivedIcon className={classes.statIcon} />
        },
        {
            label: 'Success',
            value: pushStatusCounts.success,
            color: '#22C55E',
            bgColor: theme.palette.type === 'dark' ? 'rgba(34, 197, 94, 0.15)' : 'rgba(34, 197, 94, 0.08)',
            iconBg: 'rgba(34, 197, 94, 0.2)',
            icon: <CheckCircleOutlineIcon className={classes.statIcon} />
        },
        {
            label: 'Failed',
            value: pushStatusCounts.failed,
            color: '#EF4444',
            bgColor: theme.palette.type === 'dark' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(239, 68, 68, 0.08)',
            iconBg: 'rgba(239, 68, 68, 0.2)',
            icon: <ErrorOutlineIcon className={classes.statIcon} />
        },
    ];

    // Stats config for campaign
    const campaignStatsConfig = [
        {
            label: 'Total Campaigns',
            value: campaignStats.total,
            color: theme.palette.type === 'dark' ? '#E5E7EB' : '#374151',
            bgColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
            iconBg: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
            icon: <EmailIcon className={classes.statIcon} />
        },
        {
            label: 'Instant',
            value: campaignStats.instant,
            color: '#3B82F6',
            bgColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.15)' : 'rgba(59, 130, 246, 0.08)',
            iconBg: 'rgba(59, 130, 246, 0.2)',
            icon: <SendIcon className={classes.statIcon} />
        },
        {
            label: 'Scheduled',
            value: campaignStats.scheduled,
            color: '#F59E0B',
            bgColor: theme.palette.type === 'dark' ? 'rgba(245, 158, 11, 0.15)' : 'rgba(245, 158, 11, 0.08)',
            iconBg: 'rgba(245, 158, 11, 0.2)',
            icon: <ScheduleIcon className={classes.statIcon} />
        },
        {
            label: 'Completed',
            value: campaignStats.completed,
            color: '#10B981',
            bgColor: theme.palette.type === 'dark' ? 'rgba(16, 185, 129, 0.15)' : 'rgba(16, 185, 129, 0.08)',
            iconBg: 'rgba(16, 185, 129, 0.2)',
            icon: <CheckCircleOutlineIcon className={classes.statIcon} />
        }
    ];

    const statsConfig = selectedType === 'push' ? pushStatsConfig : campaignStatsConfig;

    // View dialog content for campaign
    const viewDialogContent = viewingCampaign && (
        <div className={classes.viewDialogContent}>
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Sender Email</Typography>
                <div className={classes.viewValue}>{viewingCampaign.sender_email || '-'}</div>
            </div>
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Subject</Typography>
                <div className={classes.viewValue}>{viewingCampaign.email_subject || '-'}</div>
            </div>

            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Template Name</Typography>
                <div className={classes.viewValue}>{viewingCampaign.email_template_name || '-'}</div>
            </div>

            <div className={classes.viewSection}>
                <div className={classes.viewHeader}>
                    <Typography className={classes.viewLabel}>HTML Preview</Typography>
                    <Tooltip title={htmlCopied ? "Copied!" : "Copy HTML"} arrow>
                        <IconButton
                            size="small"
                            onClick={copyHtml}
                            className={`${classes.copyIconButton} ${htmlCopied ? classes.copyIconButtonSuccess : ''}`}
                        >
                            {htmlCopied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                        </IconButton>
                    </Tooltip>
                </div>
                {getHtmlPreview(viewingCampaign) ? (
                    <div
                        className={classes.htmlPreview}
                        dangerouslySetInnerHTML={{
                            __html: getHtmlPreview(viewingCampaign)
                        }}
                        onClick={(e) => {
                            if (e.target.tagName === 'A' && e.target.href) {
                                e.preventDefault();
                                window.open(e.target.href, '_blank', 'noopener,noreferrer');
                            }
                        }}
                    />
                ) : (
                    <div className={classes.viewValue}>-</div>
                )}
            </div>

            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Campaign Type</Typography>
                <div className={classes.viewValue}>{capitalizeWords(viewingCampaign.campaign_type) || '-'}</div>
            </div>

            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Scheduled Time</Typography>
                <div className={classes.viewValue}>
                    {viewingCampaign.time ? moment(viewingCampaign.time).format(globalDateFormat) : '-'}
                </div>
            </div>

            {/* Count Statistics */}
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Email Statistics</Typography>
                <div className={classes.viewValue}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
                        <div>Total: {viewingCampaign.total_count || 0}</div>
                        <div>Success: {viewingCampaign.success_count || 0}</div>
                        <div>Delivered: {viewingCampaign.delivered_count || 0}</div>
                        <div>Received: {viewingCampaign.received_count || 0}</div>
                        <div>Queue: {viewingCampaign.queue_count || 0}</div>
                        <div>Failed: {viewingCampaign.failed_count || 0}</div>
                        <div>Compliant: {viewingCampaign.compliant_count || 0}</div>
                        <div>Delivery: {calculateDeliveryPercentage(viewingCampaign)}</div>
                    </div>
                </div>
            </div>
        </div>
    );

    // Attachment Preview Modal Content
    const attachmentPreviewContent = (
        <>
            {selectedAttachments.length > 0 && (
                <div className={classes.attachmentTabsContainer}>
                    <Tabs
                        value={activeAttachmentTab}
                        onChange={handleAttachmentTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {selectedAttachments.map((attachment, index) => {
                            const filename = getAttachmentFilename(attachment);
                            const truncatedName = filename.length > 20
                                ? `${filename.substring(0, 17)}...`
                                : filename;
                            return (
                                <Tab
                                    key={index}
                                    label={truncatedName}
                                    className={classes.attachmentTab}
                                />
                            );
                        })}
                    </Tabs>
                </div>
            )}
            {renderAttachmentPreview()}
        </>
    );

    // HTML Preview Modal Content
    const htmlPreviewContent = selectedEmail && (
        selectedEmail.html ? (
            <div
                className={classes.htmlPreviewContent}
                dangerouslySetInnerHTML={{ __html: highlightTemplateParams(extractBodyContent(selectedEmail.html)) }}
                onClick={(e) => {
                    if (e.target.tagName === 'A' && e.target.href) {
                        e.preventDefault();
                        window.open(e.target.href, '_blank', 'noopener,noreferrer');
                    }
                }}
            />
        ) : (
            <div className={classes.noHtmlText}>No HTML content available</div>
        )
    );

    return (
        <>
            <CSVLink
                ref={csvLink}
                data={dataForExport}
                filename={generateFileName()}
                style={{ display: 'none' }}
            />

            {/* Push Email Modal */}
            <ComposePushEmailModal
                open={pushModalOpen}
                onClose={() => setPushModalOpen(false)}
                onSend={handleSendPushEmail}
                userData={userData}
            />

            {/* Campaign Modal */}
            <ComposeCampaignModal
                open={campaignModalOpen}
                onClose={handleCloseCampaignModal}
                onSend={handleSendCampaign}
                isEditMode={isEditMode}
                editingCampaign={editingCampaign}
                userData={userData}
            />

            {/* Attachment Preview Modal */}
            <ModalOmni
                open={attachmentPreviewOpen}
                handleClose={handleCloseAttachmentPreview}
                title={`Attachments (${selectedAttachments.length})`}
                content={attachmentPreviewContent}
                customWidth={700}
                maxWidth="md"
                actions={
                    <Box display="flex" justifyContent="space-between" width="100%">
                        {selectedAttachments.length > 0 && (
                            <ButtonOmni
                                onClick={() => handleDownloadAttachment(selectedAttachments[activeAttachmentTab])}
                                label="Download"
                                size="small"
                                startIcon={<GetAppIcon />}
                            />
                        )}
                        <ButtonOmni
                            onClick={handleCloseAttachmentPreview}
                            variant="outlined"
                            label="Close"
                            size="small"
                        />
                    </Box>
                }
            />

            {/* HTML Preview Modal */}
            <ModalOmni
                open={htmlPreviewOpen}
                handleClose={handleCloseHtmlPreview}
                title="Email HTML Preview"
                content={htmlPreviewContent}
                customWidth={700}
                maxWidth="md"
                actions={
                    <ButtonOmni
                        onClick={handleCloseHtmlPreview}
                        variant="outlined"
                        label="Close"
                        size="small"
                    />
                }
            />
            {/* Campaign View Dialog */}
            <ModalOmni
                open={viewDialogOpen}
                handleClose={handleCloseViewDialog}
                title="Campaign Details"
                content={viewDialogContent}
                customWidth={700}
                maxWidth="md"
                actions={
                    <ButtonOmni
                        onClick={handleCloseViewDialog}
                        variant="outlined"
                        label="Close"
                        size="small"
                    />
                }
            />

            {/* Delete Confirmation Dialog */}
            <DeleteConfirmationDialog
                open={deleteDialogOpen}
                onClose={() => {
                    setDeleteDialogOpen(false);
                    setDeletingCampaign(null);
                }}
                onConfirm={handleDeleteConfirm}
                title="Delete Campaign"
                message={`Are you sure you want to delete this campaign? This action cannot be undone.`}
                confirmLabel="Delete"
                cancelLabel="Cancel"
                loading={isDeleting}
            />

            {/* Header Row */}
            <div className={classes.headerRow}>
                <div className={classes.leftControls}>
                    <div className={classes.selectContainer}>
                        <FormControl variant="outlined" size="small">
                            <Select
                                value={selectedType}
                                onChange={handleTypeChange}
                                displayEmpty
                                className={classes.typeSelect}
                            >
                                <MenuItem value="push">Push</MenuItem>
                                <MenuItem value="campaign">Campaign</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.datePickerContainer}>
                        <DateRangePickerOmni
                            startDate={dateRange.startDate}
                            endDate={dateRange.endDate}
                            onDateChange={handleDateChange}
                            color="black"
                        />
                    </div>
                </div>
                <div className={classes.rightControls}>
                    <Tooltip title="Refresh" arrow>
                        <IconButton
                            className={classes.refreshButton}
                            onClick={handleRefresh}
                            disabled={isLoading}
                        >
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>

            {/* Chart Section */}
            <div className={classes.chartSection}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={4}>
                        <EmailCampaignChart emailData={data} isCampaignMode={selectedType === 'campaign'} />
                    </Grid>
                    <Grid item xs={12} md={6} lg={8}>
                        <Paper className={classes.overviewCard}>
                            <Typography variant="h6" className={classes.overviewTitle}>
                                <TrendingUpIcon style={{ color: theme.palette.primary.main }} />
                                {selectedType === 'push' ? 'Push Overview' : 'Campaign Overview'}
                            </Typography>
                            <div className={classes.statsGrid}>
                                {statsConfig.map((stat, index) => (
                                    <Box
                                        key={index}
                                        className={classes.statCard}
                                        style={{ backgroundColor: stat.bgColor }}
                                    >
                                        <div
                                            className={classes.statIconWrapper}
                                            style={{ backgroundColor: stat.iconBg }}
                                        >
                                            {React.cloneElement(stat.icon, { style: { color: stat.color } })}
                                        </div>
                                        <Typography className={classes.statValue} style={{ color: stat.color }}>
                                            {stat.value.toLocaleString()}
                                        </Typography>
                                        <Typography className={classes.statLabel} style={{ color: theme.palette.text.secondary }}>
                                            {stat.label}
                                        </Typography>
                                    </Box>
                                ))}
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

            {/* Export Button */}
            {data && data.length > 0 && (
                <Box display="flex" justifyContent="flex-end" marginBottom={2}>
                    <ButtonOmniNew
                        onClick={handleExport}
                        buttonType="export"
                        label={'Export'}
                        variant="outlined"
                        size="small"
                        loading={isExporting}
                        disabled={isExporting}
                    />
                </Box>
            )}

            {/* Table Section */}
            <div className={classes.tableSection}>
                {selectedType === 'push' ? (
                    <TableOmniNewAnimated
                        loading={isLoading}
                        rows={data}
                        headCells={pushHeadCells}
                        perPageRows={currentParams.limit}
                        curPage={currentParams.page}
                        setCurrentParams={setCurrentParams}
                        totalItems={totalItems}
                        emptyMessage="No Push Emails Found"
                        onDownloadClick={handleDownloadSingleRow}
                    />
                ) : (
                    <TableOmniNewAnimated
                        loading={isLoading}
                        rows={data}
                        headCells={campaignHeadCells}
                        perPageRows={currentParams.limit}
                        curPage={currentParams.page}
                        setCurrentParams={setCurrentParams}
                        totalItems={totalItems}
                        emptyMessage="No Campaigns Found"
                        onDeleteClick={handleDeleteClick}
                        onViewClick={handleViewClick}
                        onDownloadClick={handleDownloadSingleRow}
                    />
                )}
            </div>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}

export default CompletedCampaignTab;